module.exports = __webpack_public_path__ + "img/DK12626509.2557921d.png";